/** ArchiPro params stripped from outbound URLs before persisting `ExternalURL`. */
const TRACKING_PARAMS_TO_STRIP = [
    '_ap_pageid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    '__apid',
] as const;

/**
 * Strip ArchiPro outbound tracking params before persisting ExternalURL so
 * Snowflake host analysis stays clean. Returns null when the URL cannot be parsed.
 */
export function stripTrackingParamsFromExternalUrl(
    website: string,
): string | null {
    try {
        const url = new URL(website);
        for (const key of TRACKING_PARAMS_TO_STRIP) {
            url.searchParams.delete(key);
        }
        return url.toString();
    } catch {
        return null;
    }
}
